import { __assign, __extends } from "tslib";
import React from 'react';
import { window, utils } from 'pro-gallery-lib';
import GalleryDebugMessage from './galleryDebugMessage';
import itemView from '../../item/itemView.js';
import { GalleryComponent } from '../../galleryComponent';
var GalleryView = /** @class */ (function (_super) {
    __extends(GalleryView, _super);
    function GalleryView(props) {
        var _this = _super.call(this, props) || this;
        _this.handleArrowKeys = _this.handleArrowKeys.bind(_this);
        _this.showMoreItems = _this.showMoreItems.bind(_this);
        _this.createGalleryConfig = _this.createGalleryConfig.bind(_this);
        _this.screenLogs = _this.screenLogs.bind(_this);
        _this.createGallery = _this.createGallery.bind(_this);
        _this.id = Date.now() + '|' + Math.floor(Math.random() * 10000);
        _this.state = {
            currentIdx: 0,
        };
        return _this;
    }
    GalleryView.prototype.handleArrowKeys = function (e) {
        var activeItemIdx = window.document.activeElement.getAttribute('data-idx');
        if (activeItemIdx) {
            var findNeighborItem = this.props.actions.findNeighborItem ||
                this.props.galleryStructure.findNeighborItem ||
                (function () { }); //temp change for tests to pass
            var idx = Number(activeItemIdx);
            var newIdx = -1;
            switch (e.keyCode || e.charCode) {
                case 38: //up
                    newIdx = findNeighborItem(idx, 'up');
                    break;
                case 37: //left
                    newIdx = findNeighborItem(idx, this.props.styleParams.isRTL ? 'right' : 'left');
                    break;
                case 40: //down
                    newIdx = findNeighborItem(idx, 'down');
                    break;
                case 39: //right
                    newIdx = findNeighborItem(idx, this.props.styleParams.isRTL ? 'left' : 'right');
                    break;
            }
            //if nextIdx is below the lastVisibleItemIdx (higher idx), we will ignore the findNeighborItem answer and stay on the same item
            if (newIdx > this.lastVisibleItemIdx()) {
                newIdx = idx;
            }
            if (newIdx >= 0) {
                e.preventDefault();
                e.stopPropagation();
                utils.setStateAndLog(this, 'Set Gallery Current Item', {
                    currentIdx: newIdx,
                });
                return false;
            }
        }
        return true;
    };
    GalleryView.prototype.lastVisibleItemIdxInHeight = function (height) {
        for (var i = this.props.galleryStructure.items.length - 1; i >= 0; i--) {
            var item = this.props.galleryStructure.items[i];
            var isVisible = item.offset.top < height;
            if (isVisible) {
                return i;
            }
        }
        return this.items.length - 1;
    };
    GalleryView.prototype.lastVisibleItemIdx = function () {
        //the item must be visible and above the show more button
        return this.lastVisibleItemIdxInHeight(this.props.container.galleryHeight - 100);
    };
    GalleryView.prototype.showMoreItems = function () {
        var _this = this;
        if (this.props.styleParams.isAccessible) {
            // tal - I left this check since we do not want to focus the last item in non-accessibility mode
            //find the last visible item and focus on it
            try {
                var lastItemIdx = this.lastVisibleItemIdx();
                utils.setStateAndLog(this, 'Focus on Last Gallery Item', {
                    currentIdx: lastItemIdx + 1,
                }, function () {
                    _this.props.actions.toggleLoadMoreItems();
                });
            }
            catch (e) {
                console.warn('Cannot find item to focus', e);
            }
        }
        else {
            this.props.actions.toggleLoadMoreItems();
        }
    };
    GalleryView.prototype.createGallery = function (showMore) {
        var _a = this.props, itemsLoveData = _a.itemsLoveData, styleParams = _a.styleParams, container = _a.container, galleryStructure = _a.galleryStructure, getVisibleItems = _a.getVisibleItems;
        var galleryConfig = this.createGalleryConfig();
        var showMoreContainerHeight = 138; //according to the scss
        var debugMsg = React.createElement(GalleryDebugMessage, __assign({}, this.props.debug));
        var galleryHeight;
        if (showMore) {
            galleryHeight = container.galleryHeight - showMoreContainerHeight;
        }
        else {
            galleryHeight = galleryStructure.height + 'px';
        }
        var galleryStructureItems = getVisibleItems(galleryStructure.galleryItems, container);
        var layout = galleryStructureItems.map(function (item, index) {
            return React.createElement(itemView, item.renderProps(__assign(__assign(__assign({}, galleryConfig), itemsLoveData[item.id]), { visible: item.isVisible, key: "itemView-" + item.id + "-" + index })));
        });
        return (React.createElement("div", { id: "pro-gallery-container", className: 'pro-gallery inline-styles ' +
                (styleParams.oneRow ? ' one-row slider hide-scrollbars ' : '') +
                (styleParams.isAccessible ? ' accessible ' : '') +
                (styleParams.isRTL ? ' rtl ' : ' ltr '), style: {
                height: galleryHeight,
                overflowX: 'hidden',
            }, onKeyDown: this.handleArrowKeys },
            React.createElement("div", { id: "pro-gallery-margin-container", style: {
                    margin: styleParams.galleryMargin + 'px',
                    height: galleryHeight,
                    width: this.props.container.galleryWidth - styleParams.imageMargin,
                    overflow: 'visible',
                    position: 'relative',
                } },
                debugMsg,
                layout)));
    };
    GalleryView.prototype.createGalleryConfig = function () {
        return {
            scrollingElement: this.props.scrollingElement,
            scroll: this.props.scroll,
            container: this.props.container,
            styleParams: this.props.styleParams,
            watermark: this.props.watermark,
            settings: this.props.settings,
            currentIdx: this.state.currentIdx,
            customHoverRenderer: this.props.customHoverRenderer,
            customInfoRenderer: this.props.customInfoRenderer,
            domId: this.props.domId,
            gotFirstScrollEvent: this.props.gotFirstScrollEvent,
            playingVideoIdx: this.props.playingVideoIdx,
            nextVideoIdx: this.props.nextVideoIdx,
            noFollowForSEO: this.props.noFollowForSEO,
            isPrerenderMode: this.props.isPrerenderMode,
            actions: {
                eventsListener: this.props.actions.eventsListener,
            },
        };
    };
    GalleryView.prototype.screenLogs = function () {
        return utils.shouldDebug('screenLogs') ? (React.createElement("div", { className: "screen-logs" },
            "URL width: ",
            utils.parseGetParam('width'),
            ", Container:",
            ' ',
            JSON.stringify(this.props.container.galleryWidth),
            ", window.document.body.clientWidth ",
            document.body.clientWidth,
            ", window.innerWidth ",
            window.innerWidth,
            ", window.screen.width:",
            ' ',
            window.screen.width)) : ('');
    };
    GalleryView.prototype.returnButtonStyle = function (styleParams) {
        var btnStyle = {};
        if (utils.isMobile()) {
            if (typeof styleParams.loadMoreButtonFont !== 'undefined') {
                btnStyle.font = styleParams.loadMoreButtonFont.value;
                btnStyle.textDecoration = styleParams.textDecorationLoadMore;
            }
            if (typeof styleParams.loadMoreButtonFontColor !== 'undefined') {
                btnStyle.color = styleParams.loadMoreButtonFontColor.value;
                btnStyle.textDecorationColor =
                    styleParams.loadMoreButtonFontColor.value;
            }
            if (typeof styleParams.loadMoreButtonColor !== 'undefined') {
                btnStyle.background = styleParams.loadMoreButtonColor.value;
            }
            if (typeof styleParams.loadMoreButtonBorderColor !== 'undefined') {
                btnStyle.borderColor = styleParams.loadMoreButtonBorderColor.value;
            }
            if (typeof styleParams.loadMoreButtonBorderRadius !== 'undefined') {
                btnStyle.borderRadius = styleParams.loadMoreButtonBorderRadius;
            }
            if (typeof styleParams.loadMoreButtonBorderWidth !== 'undefined') {
                btnStyle.borderWidth = styleParams.loadMoreButtonBorderWidth;
            }
        }
        return btnStyle;
    };
    GalleryView.prototype.createShowMoreButton = function () {
        if (typeof this.props.customLoadMoreRenderer === 'function') {
            return (React.createElement("div", { onClick: this.showMoreItems }, this.props.customLoadMoreRenderer(this.props)));
        }
        var styleParams = this.props.styleParams;
        var showMoreButton = false;
        var buttonState = this.props.displayShowMore;
        var shouldShowButton = buttonState &&
            this.props.galleryStructure.height > this.props.container.height;
        var btnStyle = this.returnButtonStyle(styleParams);
        if (shouldShowButton) {
            var buttonText = styleParams.loadMoreButtonText || 'Load More';
            showMoreButton = (React.createElement("div", { className: 'show-more-container' +
                    (utils.isMobile() ? ' pro-gallery-mobile-indicator' : '') },
                React.createElement("button", { tabIndex: utils.getTabIndex('loadMoreButton'), id: 'show-more-' + this.props.domId, className: "show-more", onClick: this.showMoreItems, onMouseDown: function (e) { return e.preventDefault(); }, "data-hook": "show-more", "aria-label": buttonText, style: btnStyle }, buttonText)));
        }
        return showMoreButton;
    };
    //-----------------------------------------| RENDER |--------------------------------------------//
    GalleryView.prototype.render = function () {
        if (utils.isVerbose()) {
            console.count('galleryView render');
            console.time('Rendering Gallery took ');
            console.log('[DEBUG_RENDER] GalleryView styleParams', this.props.styleParams);
            console.log('[DEBUG_RENDER] GalleryView props changed', utils.printableObjectsDiff(this.lastProps || {}, this.props));
            this.lastProps = __assign({}, this.props);
            console.log('[DEBUG_RENDER] GalleryView state changed', utils.printableObjectsDiff(this.lastState || {}, this.state));
            this.lastState = __assign({}, this.state);
            this.renderCount = (this.renderCount || 0) + 1;
        }
        var showMore = this.createShowMoreButton();
        var gallery = this.createGallery(showMore);
        if (utils.isVerbose()) {
            console.timeEnd('Rendering Gallery took ');
        }
        var screenLogs = this.screenLogs();
        return (React.createElement("div", { className: 'pro-gallery-parent-container', key: "pro-gallery-" + this.id, role: "region", "aria-label": this.props.proGalleryRegionLabel },
            screenLogs,
            gallery,
            showMore));
    };
    return GalleryView;
}(GalleryComponent));
export default GalleryView;
//# sourceMappingURL=galleryView.js.map